import React from 'react';
import {useBedManagementStyles} from '../../bmStyle';
import clsx from 'clsx';

const BedManagementChipButton = ({label, active, onClick}) => {
    const classes = useBedManagementStyles();

    return (
        <div
            className={clsx(classes.chipClass, active && 'active')}
            onClick={onClick}
        >
            {label}
        </div>
    );
};

export default BedManagementChipButton;